import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Field, TextareaField, TextField, Btn, FormButtonDisabler, IModalComponent, Validations, MultiDropdownField, DropdownField } from '@samc/centricity-core';
import { IInternalField, IInternalFieldsFormModel, ITextValuePair } from '@/Interfaces';

@Component({
  name: 'internal-field-modal',
  components: { Field, TextareaField, TextField, Btn, FormButtonDisabler, MultiDropdownField, DropdownField }
})
export default class InternalFieldsFormModel extends Vue implements IModalComponent {
  @Prop() public addCloseProp!: (callback: () => Promise<IInternalFieldsFormModel | undefined>) => void;
  @Prop() public closeProp!: () => void;
  @Prop() public categoriesDataSource!: ITextValuePair<string>[];
  @Prop() public overridableDataSource!: ITextValuePair<string>[];
  @Prop() public entitledToEditDescription!: boolean;
  @Prop() public canEditName!: boolean;
  @Prop() public internalField!: IInternalField;

  public selectedCategoryName: string[] = [];
  public overridable: string = '';

  public showValidations: boolean = false;

  public get validations(): Validations<{ displayName: string, category: string, description: string, overridable: string }> {
    let result: Validations<{ displayName: string, category: string, description: string, overridable: string }> = {}
    if (this.internalField.displayName.length == 0) {
      result.displayName = 'display Name is required!';
    }
    if (this.internalField.categoryName.length == 0) {
      result.category = 'Category is required!';
    }
    if (this.internalField.description === null || this.internalField.description.trim().length === 0) {
      result.description = 'Description is required!';
    }
    if (this.internalField.overridable === null || this.internalField.overridable.trim().length === 0) {
      result.overridable = 'Value for Overridable is required!';
    }
    return result;
  }

  public mounted() {
    this.selectedCategoryName = this.internalField.categoryName.split(',').map(category => category.trim());
    this.overridable = this.internalField.overridable;
    this.addCloseProp(async () => {
      this.showValidations = true;
      if (Object.keys(this.validations).length === 0) {
        return {
          id: this.internalField.id,
          displayName: this.internalField.displayName,
          categoryName: this.selectedCategoryName.sort().join(', '),
          description: this.internalField.description ?? '',
          overridable: this.overridable ?? 'No Protection' //As per requirement, default value is 'No Protection'
        };
      }
    });
  }

  public AddItem(newCategory: ITextValuePair<string>) {
    this.categoriesDataSource.push(newCategory);
    this.categoriesDataSource.sort((category1, category2) =>
      category1.text.toLowerCase().localeCompare(category2.text.toLowerCase()
      ));
  }
}